"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: props.size || props.width || "24px",
    id: "info",
    height: props.size || props.height || "24px"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("circle", {
    id: "info__a",
    cx: 8,
    cy: 8,
    r: 8
  })), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("mask", {
    id: "info__b",
    fill: "#fff"
  }, /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#info__a"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    fill: "#00C7B1",
    fillRule: "nonzero",
    xlinkHref: "#info__a"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    mask: "url(#info__b)",
    fill: props.color,
    fillRule: "nonzero"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 0h16v16H0z"
  }))), /*#__PURE__*/_react["default"].createElement("text", {
    fontFamily: "Gotham-Bold, Gotham",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#FFF"
  }, /*#__PURE__*/_react["default"].createElement("tspan", {
    x: 6.188,
    y: 12
  }, "i"))));
};
var _default = exports["default"] = SvgComponent;